import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ClientLoginAndRegistrationModuleConfig, ModuleConfig } from '../../client-login-and-registration.module';

@Component({
  selector: 'make-sign-up-success',
  templateUrl: './sign-up-success.component.html',
  styleUrls: ['./sign-up-success.component.scss'],
})
export class SignUpSuccessComponent implements OnInit {
  logoUrl!: string;
  userEmailAddress = '';

  constructor(@Inject(ModuleConfig) protected config: ClientLoginAndRegistrationModuleConfig, private activatedRoute: ActivatedRoute) {
    this.userEmailAddress = this.activatedRoute.snapshot.queryParams['email'] || '';
  }

  ngOnInit(): void {
    this.logoUrl = 'assets/logos/brand-logo.svg';
  }
}
